import {
  isValidVar,
  isObject,
} from '../checkVarType';

const validateApiRes = (
  res,
  validationRules,
) => {
  let isValid = true;
  Object.keys(validationRules).forEach(
    (rule) => {
      if (isObject(validationRules[rule])) {
        Object.keys(validationRules[rule]).forEach(
          (subrule) => {
            if (res.data[rule][subrule] !== validationRules[rule][subrule]) {
              isValid = false;
            }
          },
        );
      } else if (res.data[rule] !== validationRules[rule]) {
        isValid = false;
      }
    },
  );
  return isValid;
};

// responseValidationRules:
// for specific methods it's taken from config
// for generic methos it's searched in config matching the endpoint rule
// pdp endpoint when called via generic get will not return any validation!!!
const responseValidationRules = (
  propsValidation,
  serviceConfig,
  endpoint,
) => {
  if (Object.keys(propsValidation).length > 0) {
    return propsValidation;
  }
  const serviceName = Object.keys(serviceConfig)
    .filter((conf) => serviceConfig[conf].url === endpoint)[0];
  if (isValidVar(serviceName)) {
    return serviceConfig[serviceName].validation;
  }
  return {};
};

export const handleApiResponse = (
  resp,
  propsValidation,
  serviceConfig,
) => {
  if (isValidVar(serviceConfig)) {
    return validateApiRes(resp,
      responseValidationRules(propsValidation, serviceConfig, resp.config.url))
      ? resp.data
      : {
        error: true,
        status: resp.data.status,
        code: resp.data.code,
      };
  }
  return resp;
};

export const handleApiError = (
  err,
  aborted,
) => {
  const errObj = {
    error: true,
    code: 500,
    message: 'no response',
  };
  if (aborted) {
    errObj.message = err.message;
  }
  if ('response' in err && isValidVar(err.response)) {
    if (isValidVar(err.response.code)) {
      errObj.code = err.response.code;
    }
    if (
      isValidVar(err.response.status)
      && !isValidVar(err.response.code)
    ) {
      errObj.code = err.response.status;
    }
    if (
      isValidVar(err.response.status)
      && isValidVar(err.response.code)
    ) {
      errObj.status = err.response.status;
    }
    if (isValidVar(err.response.message)) {
      errObj.message = err.response.message;
    }
    if (
      isValidVar(err.response.statusText)
      && !isValidVar(err.response.message)
    ) {
      errObj.message = err.response.statusText;
    }
    if (
      isValidVar(err.response.statusText)
      && isValidVar(err.response.message)
    ) {
      errObj.statusText = err.response.statusText;
    }
  }
  return {
    ...errObj,
  };
};
